import { FaHome, FaIdCard, FaDatabase, FaMobile } from "react-icons/fa";

// Menu configuration based on user types
// user_type: 'super_admin', 'admin', 'manager', 'user'

const menuConfig = {
  // Product Admin has limited access
  product_admin: [
    {
      id: "dashboard",
      title: "Dashboard",
      path: "/dashboard",
      icon: FaHome,
    },
    {
      id: "license",
      title: "License Creation",
      path: "/dashboard/license",
      icon: FaIdCard,
    },
    {
      id: "masters",
      title: "Masters",
      icon: FaDatabase,
      children: [
        {
          id: "user-management",
          title: "User Management",
          path: "/dashboard/masters/users",
        },
        {
          id: "school",
          title: "School",
          path: "/dashboard/masters/school",
        },
        {
          id: "Plans & Pricing",
          title: "Plans & Pricing",
          path: "/dashboard/masters/plans-pricing",
        },
        {
          id: "request-demo",
          title: "Request Demo",
          path: "/dashboard/masters/request-demo",
        },
        {
          id: "contact-request",
          title: "Contact request",
          path: "/dashboard/masters/contact-request",
        },
      ],
    },
    {
      id: "Blog",
      title: "Blog",
      path: "/dashboard/Blog",
      icon: FaIdCard,
    },
    {
      id: "appversion",
      title: "App Version",
      path: "/dashboard/appversion",
      icon: FaMobile,
    },
  ],

  // Regular user has minimal access
  user: [
    {
      id: "dashboard",
      title: "Dashboard",
      path: "/dashboard",
      icon: FaHome,
    },
  ],
};

// Function to get menu items based on user type
export const getMenuByUserType = (userType) => {
  return menuConfig[userType] || menuConfig.user;
};

// // Function to get menu items based on user ID (for custom permissions)
// export const getMenuByUserId = (userId, customMenus = {}) => {
//   if (customMenus[userId]) {
//     return customMenus[userId];
//   }
//   // Default to user menu if no custom menu found
//   return menuConfig.user;
// };

// Function to filter menu based on permissions array
export const getMenuByPermissions = (permissions = []) => {
  const allMenus = menuConfig.super_admin;

  return allMenus.filter((menu) => {
    if (permissions.includes(menu.id)) {
      if (menu.children) {
        menu.children = menu.children.filter((child) =>
          permissions.includes(child.id),
        );
      }
      return true;
    }
    return false;
  });
};

export default menuConfig;
